import { render, staticRenderFns } from "./DailyExpress.vue?vue&type=template&id=da543ac8"
import script from "./DailyExpress.vue?vue&type=script&lang=ts"
export * from "./DailyExpress.vue?vue&type=script&lang=ts"
import style0 from "./DailyExpress.vue?vue&type=style&index=0&id=da543ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports